
import React from 'react';
import { Share2, CheckCircle, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardHeader, CardTitle, CardDescription, CardFooter } from '@/components/ui/card';

interface InviteCardProps {
  tripDetails: { name: string; destination: string } | null;
  joined: boolean;
  joining: boolean;
  onJoin: () => void;
  onViewTrip: () => void;
  onGoHome: () => void;
  isAuthenticated: boolean;
}

export const InviteCard: React.FC<InviteCardProps> = ({
  tripDetails,
  joined,
  joining,
  onJoin,
  onViewTrip,
  onGoHome,
  isAuthenticated
}) => (
  <div className="flex items-center justify-center min-h-screen w-full px-4">
    <Card className="max-w-md w-full">
      <CardHeader>
        <CardTitle>
          {joined ? (
            <div className="flex items-center gap-2 text-green-600">
              <CheckCircle />
              Trip Joined
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <Share2 />
              Trip Invitation
            </div>
          )}
        </CardTitle>
        <CardDescription>
          {tripDetails ? (
            <div className="py-2">
              <p className="font-semibold text-lg">{tripDetails.name}</p>
              <p className="text-muted-foreground">{tripDetails.destination}</p>
            </div>
          ) : (
            'Loading trip details...'
          )}
        </CardDescription>
      </CardHeader>
      <CardFooter className="flex flex-col gap-2">
        {!isAuthenticated && (
          <p className="text-sm text-muted-foreground mb-2">
            Sign in or create an account to join this trip
          </p>
        )}
        
        {joined ? (
          <Button onClick={onViewTrip} className="w-full bg-glowingTeal hover:bg-glowingTeal/90">
            View Trip
          </Button>
        ) : (
          <Button 
            onClick={onJoin} 
            className="w-full bg-glowingTeal hover:bg-glowingTeal/90"
            disabled={joining || !tripDetails}
          >
            {joining ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Joining...
              </>
            ) : (
              'Join Trip'
            )}
          </Button>
        )}
        
        <Button variant="outline" onClick={onGoHome} className="w-full mt-2">
          Go to Home
        </Button>
      </CardFooter>
    </Card>
  </div>
);
